export default __webpack_public_path__ + "images/77c18a9f107f3025303a64dfb5e8e8b6-ship.png";